"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _member = require("@/api/member/member");
var _goodsDetail = require("@/api/appBasicSetup/goodsDetail");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      rules: {},
      options: [],
      ruleForm: {
        lessThanGrade: '',
        upgradeModuleStatus: 1,
        upgradeText: '',
        materiaStatus: 0,
        historyPriceStatus: 0,
        couponStyle: 1
      }
    };
  },
  mounted: function mounted() {
    this.memberQueryMemberGradeApi();
    this.getInit();
  },
  methods: {
    getInit: function getInit() {
      var _this = this;
      (0, _goodsDetail.getGoodsPageConfig)().then(function (res) {
        if (res.data) {
          _this.ruleForm = (0, _objectSpread2.default)({}, res.data);
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('当前页配置信息发生修改,是否确认修改内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _goodsDetail.editGoodsPageConfig)(_this2.ruleForm).then(function (res) {
              if (res.data) {
                _this2.$notify.success({
                  title: '温馨提示',
                  message: '保存成功！'
                });
                _this2.getInit();
              }
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    memberQueryMemberGradeApi: function () {
      var _memberQueryMemberGradeApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _member.memberQueryMemberGradeApi)();
            case 1:
              res = _context.v;
              this.options = res.data;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function memberQueryMemberGradeApi() {
        return _memberQueryMemberGradeApi2.apply(this, arguments);
      }
      return memberQueryMemberGradeApi;
    }()
  }
};